export const GET_DASHBOARD_STATS_QUERY = `
  query DashboardStats(
    $firmWhere: firms_bool_exp!
    $contractWhere: contracts_bool_exp!
    $offerWhere: offers_bool_exp!
    $taskWhere: tasks_bool_exp!
  ) {
    firms(where: $firmWhere) { id }
    contracts(where: $contractWhere) { id }
    offers_aggregate(where: $offerWhere) {
      aggregate { count }
    }
    tasks(where: $taskWhere) { id }
  }
`;

export const GET_DASHBOARD_CONTRACTS_OVERVIEW_QUERY = `
  query DashboardContractsOverview($where: contracts_bool_exp!) {
    contracts(where: $where) {
      work_status { name }
      contract_subject { name is_project_based }
    }
  }
`;

export const GET_DASHBOARD_JOBS_OVERVIEW_QUERY = `
  query DashboardJobsOverview($where: jobs_bool_exp!) {
    jobs(where: $where) {
      job_status
      job_type
      job_type_id
      job_type_rel {
        id
        name
      }
    }
  }
`;
